import { AddIcon, ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Collapse,
  Heading,
  IconButton,
  Stack,
  useDisclosure,
} from "@chakra-ui/react";
import { useFieldArray } from "react-hook-form";
import RuleItem from "../RuleItem";

const RuleBranch = ({
  label,
  color,
  control,
  register,
  schema,
  path,
  depth,
}) => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });

  const { fields, append, remove } = useFieldArray({
    control,
    name: path,
  });

  return (
    <Box mt={4} pl={3} borderLeft="4px solid" borderColor={`${color}.300`}>
      <Stack
        direction="row"
        gap={5}
        align="center"
        borderBottom="1px solid gray"
        pb={2}
      >
        <Stack direction="row" spacing={2} w="100%" alignItems="center">
          <Box
            as="button"
            width="100%"
            px={4}
            py={3}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            fontWeight="semibold"
            borderRadius="md"
            bg="#F7FAFC"
            _hover={{ bg: "gray.100" }}
            onClick={onToggle}
          >
            <Box textAlign="left">
              {" "}
              <Heading size="xs" color={`${color}.600`}>
                {label}
              </Heading>
            </Box>

            <Box
              transform={isOpen ? "rotate(180deg)" : "rotate(0deg)"}
              transition="transform 0.2s ease"
            >
              <ChevronDownIcon />
            </Box>
          </Box>
          <IconButton
            colorScheme={color}
            aria-label="Add Rule"
            borderRadius="full"
            border="none"
            size="sm"
            icon={<AddIcon />}
            onClick={() =>
              append({
                TYPE: "RULE",
                ID: `RULE_${Date.now()}`,
                TRUE_STEP: [],
                FALSE_STEP: [],
              })
            }
          />
        </Stack>
      </Stack>

      <Collapse in={isOpen} animateOpacity>
        <Stack spacing={3} mt={3}>
          {fields.map((step, index) => (
            <RuleItem
              key={step.id}
              control={control}
              register={register}
              schema={schema}
              rule={step}
              path={`${path}.${index}`}
              remove={() => remove(index)}
              depth={depth + 1}
              isStep
            />
          ))}
        </Stack>
      </Collapse>
    </Box>
  );
};

export default RuleBranch;
